import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { SettingsEntity } from '../../common';
import { environment } from '../../environments';
import { ApiBaseService } from './api-base.service';
import { Hub } from '../abstract/hub.abstract';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiSettingsService extends ApiBaseService implements OnDestroy {
  protected apiBaseUrl = environment.campusV2;
  protected routePath = `hubs/${this._hubService.hub()}/settings`;

  public hubSubscription: Subscription;

  constructor(private _hubService: Hub, private _httpClient: HttpClient) {
    super(_httpClient);

    this.hubSubscription = this._hubService.onHubChange.subscribe(() => {
      this.routePath = `hubs/${this._hubService.hub()}/settings`;
    });
  }
  ngOnDestroy(): void {
    this.hubSubscription?.unsubscribe();
  }

  public getSettings(): Promise<SettingsEntity[]> {
    const path = ``;
    return super.get<SettingsEntity[]>(path);
  }
}
